<template>
  <div class="container">
    <el-card v-loading="loading" shadow="never">
      <template slot="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Facility Occupancy'}">
            {{ $root.getHeader() }} Occupancy
          </el-breadcrumb-item>
        </el-breadcrumb>
      </template>
      <el-card shadow="never">
        <template slot="header">
        <h4 class="wallet-head">
          Occupancy
        </h4>
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="Pick a month"
          @change="getFacilityOccupancy"
        >
        </el-date-picker>
      </template>
      <el-row :gutter="10">
        <el-col :xs="6" :sm="6" :md="8" :lg="10" :xl="11">
          <h4 class="wallet-text">
            Monthly Average Occupancy: {{ Number(averageOccupancy).toFixed(2) }} %
          </h4>
        </el-col>
        <el-col :xs="4" :sm="6" :md="8" :lg="10" :xl="13">
          <h4 class="wallet-text">
            Monthly Average Yield: {{ Number(averageYield).toFixed(2) }} /SF
          </h4>
        </el-col>
      </el-row>
      <div>
      </div>
      <el-table :data="data">
        <el-table-column label="Date" prop="createdAt">
          <template slot-scope="scope">
            {{ scope.row.createdAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="Occupancy" prop="occupancy">
          <template slot-scope="scope">
            {{ scope.row.occupancy.toFixed(2) }} %
          </template>
        </el-table-column>
        <el-table-column label="Rentable Sq Ft Size" prop="facilitySize">
          <template slot-scope="scope">
            {{ scope.row.facilitySize.toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column label="Rented Sq Ft Size" prop="rentedUnitsSize">
          <template slot-scope="scope">
            {{ scope.row.rentedUnitsSize.toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column label="Rented Units" prop="rentedUnits">
        </el-table-column>
        <el-table-column label="Total Units" prop="totalUnits">
        </el-table-column>
        <el-table-column label="Total Units" prop="yield.yield">
          <template slot-scope="scope">
            {{ scope.row.yield ? scope.row.yield.yield : 'Not available' }}
          </template>
        </el-table-column>
      </el-table>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'FacilityOccupancy',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityOccupancy();
      this.loading = false;
    },
  },
  async mounted() {
    if (!this.facility) {
      return;
    }

    await this.getFacilityOccupancy();
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      data: {},
      date: new Date(),
    };
  },
  computed: {
    averageOccupancy() {
      const total = this.data.map(record => record.occupancy).reduce((p, n) => p + n, 0);
      return total ? total / this.data.length : 0;
    },
    averageYield() {
      const total = this.data.filter(record => record.yield).map(record => record.yield.yield).reduce((p, n) => p + n, 0);
      return total ? total / this.data.length : 0;
    },
  },
  methods: {
    async getFacilityOccupancy() {
      try {
        const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}/occupancy`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            month: this.date.getMonth(),
            year: this.date.getFullYear(),
          },
        });
        const data = response.data.result.occupancies;

        this.data = data;
      } catch (err) {
        this.$message({
          showClose: true,
          offset: 60,
          type: 'error',
          duration: 10000,
          message: err.response.data,
        });
      }
    },
  },
};
</script>

<style scoped>
.wallet-text {
  font-weight: 300;
}

.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityOccupancyReport.vue